angular.module('galilai.creator').controller('SocialConnectController', function($scope, api, $rootScope, $timeout) {

    $scope.init = function() {
        console.log('SocialConnectController');
    }

    $scope.hideModal = function() {
        let socialConnectModal = angular.element('#socialconnect-modal')
        if (socialConnectModal) {
            socialConnectModal.modal('hide')
        }
    }
    // Instagram is served outside /connect because grant owns that prefix, see routes/social.js
    function getConnectPath(kind) {
        if (kind == 'instagram') {
            return '/social/instagram/connect'
        }
        return '/connect/' + kind
    }

    $scope.preConnectOpen = function(kind) {
        $rootScope.$emit('startMonitoringSocialPages')
        if (IS_APP) {
            let info = getTokenWithAlert()
            if (!info) return
            window.open(window.BASE_URL + "/social-media-connect?info=" + info + '&provider=' + kind, '_system')
            $scope.hideModal()
            return
        }

        api.socialPreConnect()
        .then(function() {
            window.open(window.BASE_URL + getConnectPath(kind), '_system')
            $scope.hideModal()
        })
        .catch(function(err) {
            showError(gettext('error.generic'))
        })
    }

    $scope.showInstructions = function() {
        $rootScope.$emit('showInstructions')
    }

    $scope.connect = function(kind) {
        if (kind == 'facebook') {
            $rootScope.$emit('doFacebookAuth')
            $scope.hideModal()
        }
        if (kind == 'linkedin') {
            $scope.preConnectOpen('linkedin')
        }
        if (kind == 'instagram') {
            $scope.preConnectOpen('instagram')
        }
    }
})